import { template as template_3513bfa92f16404ab0f82a309402730e } from "@ember/template-compiler";
import StandardModal from 'eflex/components/standard-modal';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import BsForm from 'eflex/components/bs-form';
import { buildValidations, validator } from '@eflexsystems/ember-tracked-validations';
import { waitFor } from '@ember/test-waiters';
import { task } from 'ember-concurrency';
import { t } from 'ember-intl';
@buildValidations({
    quantityToReport: [
        validator('presence', true)
    ]
})
class MultipieceStandaloneInfoModal extends Component {
    @tracked
    requiredQuantity;
    save = task(waitFor(async ()=>{
        await this.args.buildStatusMultipiece.save();
        this.args.closeModal();
    }));
    static{
        template_3513bfa92f16404ab0f82a309402730e(`
    <StandardModal
      @onConfirm={{this.save.perform}}
      @size="sm"
      class="test-multipiece-standalone-info-modal"
    as |modal|>
      <modal.header>
        <div class="d-flex align-items-center w-100" >
          <h5 class="modal-title lh-sm">
            {{t "jem.setMultipieceInfo"}}
          </h5>
        </div>
      </modal.header>
      <modal.body>
        <BsForm @model={{@buildStatusMultipiece}} as |form|>
          <form.element
            @controlType="number"
            @label={{t "requiredQuantity"}}
            @property="requiredQuantity"
            class="test-required-quantity-input"
          as |el|>
            <el.control
              min={{0}}
            />
          </form.element>
        </BsForm>
      </modal.body>
      <modal.footer as |footer|>
        <footer.confirm />
      </modal.footer>
    </StandardModal>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default MultipieceStandaloneInfoModal;
